import { render, staticRenderFns } from "./SolutionDetails.vue?vue&type=template&id=05ea2a5a&scoped=true&"
import script from "./SolutionDetails.vue?vue&type=script&lang=js&"
export * from "./SolutionDetails.vue?vue&type=script&lang=js&"
import style0 from "./SolutionDetails.vue?vue&type=style&index=0&id=05ea2a5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ea2a5a",
  null
  
)

export default component.exports